<template>
  <el-dialog
      :modal="modal"
      :append-to-body="true"
      :close-on-click-modal="false"
      :visible.sync="showDialog"
      :width="width"
      :before-close="onCancel"
      class="jy-common-dialog"
      :draggable="draggable"
  >
    <!-- 弹窗标题 -->
    <template #title>
      <div class="dialog-title">
        <div class="dialog-title-word">{{ showDialogTitle }}</div>
      </div>
    </template>

    <!-- 插槽内容 -->
    <slot />

    <!-- 底部插槽 -->
    <template #footer>
      <div v-if="footer" class="dialog_footer" :class="{ small_dialog: 'small' }">
        <div class="footer_left">
          <slot name="footerLeft" />
        </div>
        <div class="footer_btns">
          <!-- 自定义右下角按钮 -->
          <template v-if="slotFooterRight">
            <slot name="footerRight" />
          </template>
          <!-- 默认按钮 -->
          <template v-else>
            <el-button
                @click="onCancel"
                v-show="showCancelBtn"
                :disabled="disableCancel"
            >{{ cancelButtonText }}</el-button
            >
            <el-button v-show="showSubmitBtn2" @click="onConfirm2">{{
                confirmButtonText2
              }}</el-button>
            <el-button
                v-show="showSubmitBtn"
                type="primary"
                :disabled="disableSubmit"
                :loading="loading"
                @click="onConfirm"
            >{{ confirmButtonText }}</el-button
            >
          </template>
        </div>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import { Message as ElMessage } from "element-ui";

export default {
  name: "Dialog",
  props: {
    title: {
      type: String,
      default: "",
    },
    footer: {
      type: Boolean,
      default: true,
    },
    modal: {
      type: Boolean,
      default: true,
    },
    showSubmitBtn: {
      type: Boolean,
      default: true,
    },
    showSubmitBtn2: {
      type: Boolean,
      default: false,
    },
    showCancelBtn: {
      type: Boolean,
      default: true,
    },
    draggable: {
      type: Boolean,
      default: true,
    },
    show: {
      type: Boolean,
      required: true,
    },
    cancelButtonText: {
      type: String,
      default: "取消",
    },
    confirmButtonText: {
      type: String,
      default: "确认",
    },
    confirmButtonText2: {
      type: String,
      default: "确认2",
    },
    disableSubmit: {
      type: Boolean,
      default: false,
    },
    disableCancel: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      showDialog: this.show,
      loading: false,
      showDialogTitle: this.title,
      slotFooterRight: false,
    };
  },
  watch: {
    show(newValue) {
      this.showDialog = newValue;
    },
    showDialog(newValue) {
      if (!newValue) {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.slotFooterRight = !!this.$slots.footerRight;
  },
  methods: {
    onCancel() {
      this.showDialog = false;
      this.loading = false;
      this.$emit("onCancel");
    },
    onConfirm() {
      this.$emit("onConfirm");
    },
    onConfirm2() {
      this.$emit("onConfirm2");
    },
  },
};
</script>

<style lang="scss" scoped>
.jy-common-dialog {
  ::v-deep(.el-dialog__body) {
    max-height: 72vh !important;
  }
}
</style>
